import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import { StreakTodayCheckIcon } from '../atoms/icons/streak_today_check_icon';
import { Colors } from '../styles/variables';
import { LottieIcon } from '../atoms/icons/lottie_icon';
import { STREAK_COUNT_UNIT } from '../../messages';
import { StreakFreezeCheckIcon } from '../atoms/icons/streak_freeze_check_icon';
import { StreakCheckIcon } from '../atoms/icons/streak_check_icon';
const CHECK_ANIMATION_DELAY_MS = 1200;
export const StreakConsecutiveDaysView = ({ streakCompletionResult, animationUrl, message }) => {
    const currentStreak = streakCompletionResult.currentStreak;
    const freezeUsedDates = streakCompletionResult.freezeUsedDates;
    const baseDate = streakCompletionResult.getBaseDateFromStartDate();
    const today = dayjs();
    const buildDays = () => {
        const completedIndex = currentStreak % 7 || 7; // 7の倍数の時は全てtrueになるようにする
        return Array.from({ length: 7 }, (_, index) => {
            const date = baseDate.add(index, 'day');
            return {
                label: date.locale('ja').format('dd'),
                isCompleted: index + 1 <= completedIndex,
                isFreezeUsed: freezeUsedDates.includes(date.format('YYYY-MM-DD')),
                isToday: date.isSame(today, 'day'),
            };
        });
    };
    return (React.createElement("div", { className: css(styles.visualGroup) },
        React.createElement(LottieIcon, { lottieDataUrl: animationUrl, classObject: styles.animationIcon }),
        React.createElement("div", { className: css(styles.countGroup) },
            React.createElement("div", { className: css(styles.count) }, currentStreak),
            React.createElement("div", { className: css(styles.countUnit) }, STREAK_COUNT_UNIT)),
        React.createElement("ul", { className: css(styles.daysRow, styles.daysRowWithMessage) }, buildDays().map((day, index) => (React.createElement("li", { className: css(styles.dayItem), key: `${day.label}-${index}` },
            React.createElement("span", { className: css(styles.dayLabel, day.isToday && styles.dayLabelToday) }, day.label),
            day.isToday ? (React.createElement("div", { className: css(styles.dayIconFilled, styles.dayIconMargin) },
                React.createElement("div", { className: css(styles.dayIconPlaceholder) }),
                React.createElement(StreakTodayCheckIcon, { classObject: styles.dayIconLottie, delayMs: CHECK_ANIMATION_DELAY_MS }))) : day.isFreezeUsed ? (React.createElement(StreakFreezeCheckIcon, null)) : day.isCompleted ? (React.createElement(StreakCheckIcon, null)) : (React.createElement("div", { className: css(styles.dayIconPlaceholder, styles.dayIconMargin) })))))),
        React.createElement("div", { className: css(styles.message) }, message)));
};
const fadeIn = {
    '0%': { opacity: 0 },
    '100%': { opacity: 1 },
};
const styles = StyleSheet.create({
    countGroup: {
        textAlign: 'center',
    },
    animationIcon: {
        width: 265,
        height: 170,
        margin: '0 auto 30px',
        display: 'block',
        animationName: [fadeIn],
        animationDuration: '0.5s',
        animationTimingFunction: 'ease-out',
        animationDelay: '0s',
        animationFillMode: 'both',
    },
    visualGroup: {
        margin: '0 5px',
    },
    count: {
        fontSize: 96,
        lineHeight: '96px',
        fontWeight: 'bold',
        letterSpacing: 3.84,
        textAlign: 'center',
        textShadow: '0 0 30px rgba(0, 145, 160, 0.08)',
        background: 'linear-gradient(180deg, #FEB75F 7.29%, #FF7337 79.69%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        animationName: [fadeIn],
        animationDuration: '0.5s',
        animationTimingFunction: 'ease-out',
        animationDelay: '0.3s',
        animationFillMode: 'both',
    },
    countUnit: {
        fontSize: 24,
        lineHeight: 1,
        fontWeight: 'bold',
        color: Colors.Orange,
        textAlign: 'center',
        margin: '14px 0 40px',
        animationName: [fadeIn],
        animationDuration: '0.5s',
        animationTimingFunction: 'ease-out',
        animationDelay: '0.5s',
        animationFillMode: 'both',
    },
    daysRow: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: 24,
        animationName: [fadeIn],
        animationDuration: '0.5s',
        animationTimingFunction: 'ease-out',
        animationDelay: '0.7s',
        animationFillMode: 'both',
    },
    daysRowWithMessage: {
        paddingBottom: 24,
    },
    message: {
        fontSize: 18,
        lineHeight: '140%',
        letterSpacing: 0.56,
        textAlign: 'center',
        margin: '0 16px 24px',
        whiteSpace: 'pre-wrap',
    },
    dayItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 4,
        flex: 1,
    },
    dayLabel: {
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: 1.4,
        color: Colors.GrayDarkest,
        letterSpacing: 0.56,
    },
    dayLabelToday: {
        color: Colors.Orange,
    },
    dayIconFilled: {
        width: 34,
        height: 34,
        position: 'relative',
    },
    dayIconLottie: {
        position: 'absolute',
        width: 46,
        height: 46,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    },
    dayIconPlaceholder: {
        width: 33,
        height: 33,
        borderRadius: '50%',
        backgroundColor: Colors.Gray,
    },
    dayIconMargin: {
        margin: '5px 0',
    },
});
